import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const ReviewReport = () => {
  return (
    <Container>
      <h2 className="display-6 fw-bold my-4">Referee’s peer-review reports</h2>
      <hr />

      <p className="joab-common-para my-2 ">
        The referee’s peer review report will indicate mainly any technical
        failings that need to be addressed before the authors’ case is
        established.
      </p>
    </Container>
  );
};

export default ReviewReport;
